import { styled } from '@mui/material/styles';

import { palette } from '../../theme';
import { Icon } from '../Icon';

import {
    StyledLinkProperties,
    StyledButtonProperties,
    StyledLinkTextProperties,
} from './IconLink.types';

export const StyledLink = styled('a')<StyledLinkProperties>`
    position: relative;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 6.8rem;
    height: 100%;
    text-decoration: none;
    cursor: pointer;
    background: ${({ $background }) => $background};
    outline: none;

    ${({ theme }) => theme.breakpoints.up('desktop')} {
        width: 7.8rem;
    }

    &:after {
        position: absolute;
        top: 0.6rem;
        right: 1rem;
        bottom: 0.6rem;
        left: 1rem;
        display: none;
        pointer-events: none;
        content: '';
        border: 2px solid ${palette.common.blue};
        border-radius: 0.8rem;

        ${({ theme }) => theme.breakpoints.up('desktop')} {
            top: 1rem;
            right: 1.2rem;
            bottom: 1rem;
            left: 1.2rem;
        }
    }

    &:focus-visible::after {
        display: block;
    }
`;

export const StyledButton = styled('button')<StyledButtonProperties>`
    position: relative;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 6.8rem;
    height: 100%;
    text-decoration: none;
    cursor: pointer;
    background: transparent;
    border: none;
    outline: none;

    &:hover {
        background: ${({ $background }) => $background};
    }

    ${({ theme }) => theme.breakpoints.up('desktop')} {
        width: 7.8rem;
        padding-top: 1.4rem;
        padding-bottom: 1.5rem;
    }

    &:after {
        position: absolute;
        top: 0.6rem;
        right: 1rem;
        bottom: 0.6rem;
        left: 1rem;
        display: none;
        pointer-events: none;
        content: '';
        border: 2px solid ${palette.common.blue};
        border-radius: 0.8rem;

        ${({ theme }) => theme.breakpoints.up('desktop')} {
            top: 1rem;
            right: 1.2rem;
            bottom: 1rem;
            left: 1.2rem;
        }
    }

    &:focus-visible::after {
        display: block;
    }
`;

export const StyledIcon = styled(Icon)`
    && {
        cursor: pointer;
    }
`;

export const StyledLinkText = styled('span')<StyledLinkTextProperties>`
    margin-top: ${({ theme }) => theme.spacing(4)};
    font-family: thegymgroupsans-headline;
    font-size: 1.1rem;
    font-weight: 800;
    line-height: 1.4rem;
    color: ${({ $color }) => $color};

    ${({ theme }) => theme.breakpoints.up('desktop')} {
        line-height: 1.6rem;
    }

    ${({ $truncate }) =>
        $truncate &&
        `
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;
    `}
`;
